export function calculateAddOnPrice(
  quantity: number | boolean,
  price: number,
  unitSize: number,
): number {
  if (typeof quantity === "boolean") {
    return quantity ? price : 0;
  }

  return (quantity * price) / unitSize;
}
